import { render, staticRenderFns } from "./Facets.vue?vue&type=template&id=4819fcd6&scoped=true"
import script from "./Facets.vue?vue&type=script&lang=js"
export * from "./Facets.vue?vue&type=script&lang=js"
import style0 from "./Facets.vue?vue&type=style&index=0&id=4819fcd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819fcd6",
  null
  
)

export default component.exports